// // dashboard-frontend/src/components/AdminOnlineDonations.jsx
// import React, { useState, useEffect } from 'react';
// import DataTable from 'react-data-table-component';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import { CSVLink } from 'react-csv';

// const AdminOnlineDonations = () => {
//   const [donations, setDonations] = useState([]);
  
//   // For summary:
//   const [paidCount, setPaidCount] = useState(0);
//   const [createdCount, setCreatedCount] = useState(0);
//   const [paidTotal, setPaidTotal] = useState(0);
  
//   // For filtering:
//   const [filterStatus, setFilterStatus] = useState(''); // blank = show all
//   const [yearFilter, setYearFilter] = useState(new Date().getFullYear());
//   const [monthFilter, setMonthFilter] = useState(''); // blank = all months
//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);
  
//   const [filteredDonations, setFilteredDonations] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Fetch all online donations:
//   const fetchDonations = async () => {
//     try {
//       const res = await fetch('/api/donations/all');
//       const data = await res.json();
//       setDonations(data);
//     } catch (err) {
//       console.error("Error fetching online donations:", err);
//     }
//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchDonations();
//   }, []);

//   // Compute summary info
//   useEffect(() => {
//     const paidDonations = donations.filter(d => d.status === 'paid');
//     setPaidCount(paidDonations.length);
//     setPaidTotal(paidDonations.reduce((sum, d) => sum + Number(d.amount), 0));
    
//     const createdDonations = donations.filter(d => d.status === 'created');
//     setCreatedCount(createdDonations.length);
//   }, [donations]);

//   // Apply filters: status + year/month + optional date range
//   useEffect(() => {
//     let temp = [...donations];
    
//     // Filter by status if chosen
//     if (filterStatus) {
//       temp = temp.filter(d => d.status === filterStatus);
//     }
    
//     // Filter by year + month
//     temp = temp.filter(d => {
//       const dt = new Date(d.createdAt);
//       const yearMatches = (dt.getFullYear() === parseInt(yearFilter, 10));
//       if (!yearMatches) return false;
//       if (monthFilter) {
//         // 1 = January, 2 = Feb, ...
//         return (dt.getMonth() + 1) === parseInt(monthFilter, 10);
//       }
//       return true; // no month filter
//     });
    
//     // Filter by date range, if specified
//     if (startDate) {
//       temp = temp.filter(d => new Date(d.createdAt) >= startDate);
//     }
//     if (endDate) {
//       temp = temp.filter(d => new Date(d.createdAt) <= endDate);
//     }
    
//     setFilteredDonations(temp);
//   }, [donations, filterStatus, yearFilter, monthFilter, startDate, endDate]);

//   const columns = [
//     { name: 'Name', selector: row => row.name, sortable: true },
//     { name: 'WhatsApp', selector: row => row.whatsapp, sortable: true },
//     { name: 'Email', selector: row => row.email, sortable: true },
//     { name: 'Amount (INR)', selector: row => row.amount, sortable: true },
//     { name: 'Note', selector: row => row.note },
//     { name: 'Order ID', selector: row => row.order_id },
//     { name: 'Payment ID', selector: row => row.payment_id },
//     { name: 'Status', selector: row => row.status, sortable: true },
//     {
//       name: 'Created At',
//       selector: row => new Date(row.createdAt).toLocaleString(),
//       sortable: true
//     },
//   ];

//   // Prepare CSV headers/data
//   const csvHeaders = [
//     { label: 'Name', key: 'name' },
//     { label: 'WhatsApp', key: 'whatsapp' },
//     { label: 'Email', key: 'email' },
//     { label: 'Amount', key: 'amount' },
//     { label: 'Note', key: 'note' },
//     { label: 'Order ID', key: 'order_id' },
//     { label: 'Payment ID', key: 'payment_id' },
//     { label: 'Status', key: 'status' },
//     { label: 'Created At', key: 'createdAt' },
//   ];

//   return (
//     <div className="p-4">
//       <h2 className="text-2xl font-bold mb-4">Online Donations</h2>
      
//       {/* Summary Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
//         <div
//           className="p-4 bg-white rounded shadow cursor-pointer"
//           onClick={() => setFilterStatus('paid')}
//         >
//           <h3 className="text-xl font-semibold">Successful (Paid)</h3>
//           <p>Transactions: {paidCount}</p>
//           <p>Total Amount: ₹{paidTotal}</p>
//         </div>
//         <div
//           className="p-4 bg-white rounded shadow cursor-pointer"
//           onClick={() => setFilterStatus('created')}
//         >
//           <h3 className="text-xl font-semibold">Created (Not Paid)</h3>
//           <p>Transactions: {createdCount}</p>
//         </div>
//         <div
//           className="p-4 bg-white rounded shadow cursor-pointer"
//           onClick={() => setFilterStatus('')}
//         >
//           <h3 className="text-xl font-semibold">All</h3>
//           <p>Transactions: {donations.length}</p>
//         </div>
//       </div>

//       {/* Additional filter controls */}
//       <div className="mb-4 flex flex-wrap items-center space-x-4">
//         <div>
//           <label className="mr-2">Status Filter:</label>
//           <select
//             value={filterStatus}
//             onChange={e => setFilterStatus(e.target.value)}
//             className="border p-1 rounded"
//           >
//             <option value="">All</option>
//             <option value="paid">Paid</option>
//             <option value="created">Created</option>
//           </select>
//         </div>

//         {/* Year & Month dropdown */}
//         <div>
//           <label className="mr-2">Year:</label>
//           <select
//             value={yearFilter}
//             onChange={e => setYearFilter(e.target.value)}
//             className="border p-1 rounded"
//           >
//             {/* Make a few years selectable or generate them dynamically */}
//             <option value="2025">2025</option>
//             <option value="2024">2024</option>
//             <option value="2023">2023</option>
//             <option value="2022">2022</option>
//           </select>
//         </div>
        
//         <div>
//           <label className="mr-2">Month:</label>
//           <select
//             value={monthFilter}
//             onChange={e => setMonthFilter(e.target.value)}
//             className="border p-1 rounded"
//           >
//             <option value="">All</option>
//             <option value="1">January</option>
//             <option value="2">February</option>
//             <option value="3">March</option>
//             <option value="4">April</option>
//             <option value="5">May</option>
//             <option value="6">June</option>
//             <option value="7">July</option>
//             <option value="8">August</option>
//             <option value="9">September</option>
//             <option value="10">October</option>
//             <option value="11">November</option>
//             <option value="12">December</option>
//           </select>
//         </div>

//         {/* Date range pickers */}
//         <div>
//           <label className="mr-2">Start Date:</label>
//           <DatePicker
//             selected={startDate}
//             onChange={(date) => setStartDate(date)}
//             dateFormat="yyyy-MM-dd"
//             maxDate={endDate || new Date()}
//             placeholderText="Select start date"
//             className="border p-1 rounded"
//           />
//         </div>
//         <div>
//           <label className="mr-2">End Date:</label>
//           <DatePicker
//             selected={endDate}
//             onChange={(date) => setEndDate(date)}
//             dateFormat="yyyy-MM-dd"
//             minDate={startDate}
//             placeholderText="Select end date"
//             className="border p-1 rounded"
//           />
//         </div>

//         {/* CSV Export */}
//         <div>
//           <CSVLink
//             data={filteredDonations}
//             headers={csvHeaders}
//             filename={`online-donations-${Date.now()}.csv`}
//             className="px-4 py-2 bg-primary text-white rounded"
//           >
//             Export CSV
//           </CSVLink>
//         </div>
//       </div>

//       {loading ? (
//         <p>Loading...</p>
//       ) : (
//         <DataTable
//           columns={columns}
//           data={filteredDonations}
//           pagination
//           defaultSortField="createdAt"
//           responsive
//         />
//       )}
//     </div>
//   );
// };

// export default AdminOnlineDonations;

// dashboard-frontend/src/components/AdminOnlineDonations.jsx

import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { CSVLink } from 'react-csv';
import { fetchJSON } from '../api';

const AdminOnlineDonations = () => {
  const [donations, setDonations] = useState([]);

  // Summary
  const [paidCount, setPaidCount] = useState(0);
  const [createdCount, setCreatedCount] = useState(0);
  const [paidTotal, setPaidTotal] = useState(0);

  // Filtering
  const [filterStatus, setFilterStatus] = useState('');
  const [yearFilter, setYearFilter] = useState(new Date().getFullYear());
  const [monthFilter, setMonthFilter] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [filteredDonations, setFilteredDonations] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch all online donations
  const fetchDonations = async () => {
    try {
      const data = await fetchJSON('/api/donations/all');
      setDonations(data);
    } catch (err) {
      console.error('Error fetching online donations:', err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchDonations();
  }, []);

  // Compute summary info
  useEffect(() => {
    const paidDonations = donations.filter(d => d.status === 'paid');
    setPaidCount(paidDonations.length);
    setPaidTotal(paidDonations.reduce((sum, d) => sum + Number(d.amount), 0));

    // 'initiated' = PayU flow started but not yet completed (replaces old 'created')
    const initiatedDonations = donations.filter(d => d.status === 'initiated' || d.status === 'created');
    setCreatedCount(initiatedDonations.length);
  }, [donations]);

  // Apply filters
  useEffect(() => {
    let temp = [...donations];

    // Filter by status ('initiated' covers both new PayU and legacy 'created')
    if (filterStatus === 'initiated') {
      temp = temp.filter(d => d.status === 'initiated' || d.status === 'created');
    } else if (filterStatus) {
      temp = temp.filter(d => d.status === filterStatus);
    }

    // Filter by year/month
    temp = temp.filter(d => {
      const dt = new Date(d.createdAt);
      if (dt.getFullYear() !== parseInt(yearFilter, 10)) return false;
      if (monthFilter) {
        return dt.getMonth() + 1 === parseInt(monthFilter, 10);
      }
      return true;
    });

    // Optional date range
    if (startDate) {
      temp = temp.filter(d => new Date(d.createdAt) >= startDate);
    }
    if (endDate) {
      temp = temp.filter(d => new Date(d.createdAt) <= endDate);
    }

    setFilteredDonations(temp);
  }, [donations, filterStatus, yearFilter, monthFilter, startDate, endDate]);

  // Helper to truncate text
  const truncateText = (text, limit = 50) => {
    if (!text) return '';
    return text.length > limit ? `${text.substring(0, limit)}...` : text;
  };

  // DataTable styling
  const customStyles = {
    rows: {
      style: {
        minHeight: '60px',
      },
    },
    headCells: {
      style: {
        fontSize: '14px',
        fontWeight: 'bold',
        paddingLeft: '8px',
        paddingRight: '8px',
      },
    },
    cells: {
      style: {
        paddingLeft: '8px',
        paddingRight: '8px',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        fontSize: '14px',
      },
    },
  };

  // Table columns
  const columns = [
    {
      name: 'Name',
      selector: row => row.name,
      sortable: true,
      minWidth: '150px',
      wrap: true,
    },
    {
      name: 'WhatsApp',
      selector: row => row.whatsapp,
      sortable: true,
      minWidth: '120px',
      wrap: true,
    },
    {
      name: 'Email',
      selector: row => row.email,
      sortable: true,
      minWidth: '200px',
      wrap: true,
    },
    {
      name: 'Amount (INR)',
      selector: row => row.amount,
      sortable: true,
      minWidth: '120px',
    },
    {
      name: 'Note',
      selector: row => truncateText(row.note, 50),
      cell: row => <span title={row.note}>{truncateText(row.note, 50)}</span>,
      minWidth: '200px',
      wrap: true,
    },
    {
      name: 'PayU Txn ID',
      selector: row => row.payu_txnid || '-',
      minWidth: '180px',
      wrap: true,
    },
    {
      name: 'Pay Mode',
      selector: row => row.payment_mode || '-',
      sortable: true,
      minWidth: '100px',
    },
    {
      name: 'Status',
      selector: row => row.status,
      sortable: true,
      minWidth: '100px',
      cell: row => (
        <span className={
          row.status === 'paid'     ? 'text-green-600 font-semibold' :
          row.status === 'failed'   ? 'text-red-500 font-semibold'   :
          'text-yellow-600 font-semibold'
        }>
          {row.status}
        </span>
      ),
    },
    {
      name: 'Created At',
      selector: row => new Date(row.createdAt).toLocaleString(),
      sortable: true,
      minWidth: '160px',
      wrap: true,
    },
  ];

  // Expanded row — shows all PayU + donor details
  const ExpandedComponent = ({ data }) => (
    <div className="p-4 bg-gray-50 grid grid-cols-1 md:grid-cols-2 gap-1 text-sm">
      <p><strong>Name:</strong> {data.name}</p>
      <p><strong>WhatsApp:</strong> {data.whatsapp}</p>
      <p><strong>Email:</strong> {data.email || '-'}</p>
      <p><strong>Amount (INR):</strong> ₹{data.amount}</p>
      <p><strong>Note:</strong> {data.note || '-'}</p>
      <p><strong>Status:</strong> {data.status}</p>
      <p><strong>Payment Mode:</strong> {data.payment_mode || '-'}</p>
      <p><strong>PayU Txn ID (mihpayid):</strong> {data.payu_txnid || '-'}</p>
      <p><strong>Receipt Number:</strong> {data.receiptNumber || '-'}</p>
      <p><strong>Created At:</strong> {new Date(data.createdAt).toLocaleString()}</p>
      <p><strong>Aadhar Card:</strong> {data.aadharCard || '-'}</p>
      <p><strong>PAN Card:</strong> {data.panCard || '-'}</p>
      {data.error_message && <p className="col-span-2 text-red-500"><strong>Error:</strong> {data.error_message}</p>}
    </div>
  );

  // CSV config — PayU fields
  const csvHeaders = [
    { label: 'Name', key: 'name' },
    { label: 'WhatsApp', key: 'whatsapp' },
    { label: 'Email', key: 'email' },
    { label: 'Amount', key: 'amount' },
    { label: 'Note', key: 'note' },
    { label: 'PayU Txn ID', key: 'payu_txnid' },
    { label: 'Payment Mode', key: 'payment_mode' },
    { label: 'Status', key: 'status' },
    { label: 'Created At', key: 'createdAt' },
    { label: 'Receipt Number', key: 'receiptNumber' },
    { label: 'Aadhar Card', key: 'aadharCard' },
    { label: 'PAN Card', key: 'panCard' },
    { label: 'Error Message', key: 'error_message' },
  ];

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Online Donations</h2>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <div
          className="p-4 bg-white rounded shadow cursor-pointer hover:shadow-lg transition-shadow"
          onClick={() => setFilterStatus('paid')}
        >
          <h3 className="text-xl font-semibold">Successful (Paid)</h3>
          <p>Transactions: {paidCount}</p>
          <p>Total Amount: ₹{paidTotal}</p>
        </div>
        <div
          className="p-4 bg-white rounded shadow cursor-pointer hover:shadow-lg transition-shadow"
          onClick={() => setFilterStatus('initiated')}
        >
          <h3 className="text-xl font-semibold">Initiated (Not Paid)</h3>
          <p>Transactions: {createdCount}</p>
        </div>
        <div
          className="p-4 bg-white rounded shadow cursor-pointer hover:shadow-lg transition-shadow"
          onClick={() => setFilterStatus('')}
        >
          <h3 className="text-xl font-semibold">All</h3>
          <p>Transactions: {donations.length}</p>
        </div>
      </div>

      {/* Additional filter controls */}
      <div className="mb-4 flex flex-wrap items-center space-x-4">
        <div>
          <label className="mr-2">Status Filter:</label>
          <select
            value={filterStatus}
            onChange={e => setFilterStatus(e.target.value)}
            className="border p-1 rounded"
          >
            <option value="">All</option>
            <option value="paid">Paid</option>
            <option value="initiated">Initiated (Not Paid)</option>
            <option value="failed">Failed</option>
          </select>
        </div>

        {/* Year & Month */}
        <div>
          <label className="mr-2">Year:</label>
          <select
            value={yearFilter}
            onChange={e => setYearFilter(e.target.value)}
            className="border p-1 rounded"
          >
            <option value="2025">2025</option>
            <option value="2024">2024</option>
            <option value="2023">2023</option>
            <option value="2022">2022</option>
          </select>
        </div>

        <div>
          <label className="mr-2">Month:</label>
          <select
            value={monthFilter}
            onChange={e => setMonthFilter(e.target.value)}
            className="border p-1 rounded"
          >
            <option value="">All</option>
            <option value="1">January</option>
            <option value="2">February</option>
            <option value="3">March</option>
            <option value="4">April</option>
            <option value="5">May</option>
            <option value="6">June</option>
            <option value="7">July</option>
            <option value="8">August</option>
            <option value="9">September</option>
            <option value="10">October</option>
            <option value="11">November</option>
            <option value="12">December</option>
          </select>
        </div>

        {/* Date range pickers */}
        <div>
          <label className="mr-2">Start Date:</label>
          <DatePicker
            selected={startDate}
            onChange={date => setStartDate(date)}
            dateFormat="yyyy-MM-dd"
            maxDate={endDate || new Date()}
            placeholderText="Select start date"
            className="border p-1 rounded"
          />
        </div>
        <div>
          <label className="mr-2">End Date:</label>
          <DatePicker
            selected={endDate}
            onChange={date => setEndDate(date)}
            dateFormat="yyyy-MM-dd"
            minDate={startDate}
            placeholderText="Select end date"
            className="border p-1 rounded"
          />
        </div>

        {/* CSV Export */}
        <div>
          <CSVLink
            data={filteredDonations}
            headers={csvHeaders}
            filename={`online-donations-${Date.now()}.csv`}
            className="px-4 py-2 bg-primary text-white rounded"
          >
            Export CSV
          </CSVLink>
        </div>
      </div>

      {/* Main Table */}
      {loading ? (
        <p>Loading...</p>
      ) : (
        <DataTable
          columns={columns}
          data={filteredDonations}
          pagination
          defaultSortField="createdAt"
          responsive
          customStyles={customStyles}
          expandableRows
          expandableRowsComponent={ExpandedComponent}
        />
      )}
    </div>
  );
};

export default AdminOnlineDonations;
